import React from 'react';

const BOLD_TEXT = /(\*\*[^*\n]+\*\*)/g;

const TaskPrompt = ({ text, className = '' }) => (
  <div className={`whitespace-pre-wrap ${className}`}>
    {String(text || 'No task prompt was provided.').split(BOLD_TEXT).map((part, index) => (
      part.startsWith('**') && part.endsWith('**')
        ? <strong key={index} className="font-semibold">{part.slice(2, -2)}</strong>
        : <React.Fragment key={index}>{part}</React.Fragment>
    ))}
  </div>
);

export default TaskPrompt;
